module.exports = __webpack_public_path__ + "img/speed.f00f0b2a.png";